import { render, staticRenderFns } from "./Dispos.vue?vue&type=template&id=94d8c392"
import script from "./Dispos.vue?vue&type=script&lang=js"
export * from "./Dispos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports